import styled from 'styled-components';

import { spaceM } from '@xing-com/tokens';

const FeatureActions = styled.div`
  align-items: center;
  display: flex;
  margin-top: ${spaceM};

  & button,
  & a {
    margin-right: ${spaceM};
  }
`;

export const Styled = {
  FeatureActions,
};
